import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { TopBar } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { AppRoute } from 'routing/AppRoute.enum';
import { TableSearchContainer } from 'reusable/tableSearch/TableSearchContainer';
import { AddUserContainer } from '../addUser/AddUserContainer';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { UsersBarRoutes, WantedBarProps } from './UsersBar.types';

export const UsersBar = ({ setTableSearchQuery }: WantedBarProps) => {
  const { formatMessage } = useLocale();
  const location = useLocation();
  const { perms } = usePermissions();
  const canViewUsersLoginHistory = perms?.[Functionality.HISTORIA]?.view;

  const pageBarElements: Record<UsersBarRoutes, ReactNode | null> = {
    [AppRoute.users]: setTableSearchQuery ? (
      <>
        <TopBar.Search>
          <TableSearchContainer
            searchIconTestId="page-search"
            inputPlaceholder={formatMessage({ id: AppMessages['users.search'] })}
            searchBy="users"
            setTableSearchQuery={setTableSearchQuery}
          />
        </TopBar.Search>

        <TopBar.ButtonsWrapper>
          <AddUserContainer type="new" />
        </TopBar.ButtonsWrapper>
      </>
    ) : null,
    [AppRoute.usersLoginHistory]: <TopBar.EmptyBarWithLine />,
  };

  const currentPageBarElement = pageBarElements[location.pathname as UsersBarRoutes];

  return (
    <TopBar gridTemplateColumns="auto auto 1fr auto">
      <TopBar.Link linkTo={AppRoute.users} isActive={location.pathname === AppRoute.users}>
        {formatMessage({ id: AppMessages['users.usersList'] })}
      </TopBar.Link>

      <TopBar.Link
        linkTo={AppRoute.usersLoginHistory}
        isActive={location.pathname === AppRoute.usersLoginHistory}
        disabled={!canViewUsersLoginHistory}
        tooltipText={!canViewUsersLoginHistory ? formatMessage({ id: AppMessages['common.noPermissions'] }) : undefined}
      >
        {formatMessage({ id: AppMessages['users.loginHistory'] })}
      </TopBar.Link>

      {currentPageBarElement}
    </TopBar>
  );
};
